<template>
  <section>
    <LoadingSpinner v-if="loading" />
    <div v-else class="mx-2">
      <div class="col-md-12 w-100 my-2 card p-2">
    
        <!-- Renderizo data de clientes sin ventas -->
        <div class="mx-0 px-0 table-responsive">
          <Table
            v-if="!loading"
            class="mx-2 w-100"
            :headers="headers"
            :cols="cols"
            :data="clients"
            :model="model"
            :checkbox="false"
            :notselect="true"
            @openClient="openClient"
            >
          </Table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { monitorService, clientsService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  name: 'ClientWithoutOliverSales',
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      filtersSystem: (state) => state.campaigns.filtersSystem,
    }),
  },

  data() {
    return {
      loading: true,
      clients: [],
      model: {},
      cols: [
        [
          {
            value: "task_open_hours",
            type: 'time',
          },
        ],
        [
          {
            value: "creation_date",
          },
        ],
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            // class: "text-primary",
            type: "emit",
            emit: "openClient",
          },
        ],
        [
          {
            value: "client_status",
          },
        ],
        [
          {
            value: "signed_on",
          },
        ],
      ],
      headers: [
        {
          label: 'Time',
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        },
        {
          label: this.$t("lang.column.creationdate"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        },
        {
          label: this.$t("lang.column.client"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 1,
        },
        {
          label: 'Status',
          percentage: "10.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 1,
        },
        {
          label: 'Signed on',
          percentage: "10.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 1,
        },
      ],
      getOrderNumber: 0,
      responseOrderNumber: 0,
    };
  },
  components: {
    Table,
    LoadingSpinner,
  },

  mounted() {
    this.loadData();
    this.setCurrentRouteChild({ child: "" });
  },

  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    loadData() {
      monitorService.getClientWithoutOliverSales('23')
      .then((res) => {
        const { result } = res;
        if (result) {
          this.clients = res.result;
          this.loading = false;
        }
      });

       this.loading = false;
    },

    filter(event) {
      this.filters = event;
      this.loadData(this.orderStatus, this.filters);
    },

    openClient(client_id) {
      //"client_id", client_id);
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.banner {
  border-radius: 25em !important;
  color: #fff;
  font-size: 0.75em;
  text-align: left;
  margin-left: 1em;
  margin-right: 1em;
  margin-bottom: 0.2em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  background-color: #4d4deb;
  width: 98%;
}

.banner-message {
  margin-left: 2em;
  margin-right: 2em;
}
</style>
